/* End-of-season sale. Presentation only: never applies or stacks a discount. */
(() => {
  'use strict';
  const init = () => {
    const dialog = document.querySelector('[data-wk-sellout-dialog]');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const key = `wk-sellout-seen:${dialog.dataset.campaign}`;
    let remembered = false;
    let previousFocus = null;
    let attempts = 0;
    let timer;
    const storage = [() => window.localStorage, () => window.sessionStorage];
    const seen = () => {
      if (remembered) return true;
      for (const getStore of storage) {
        try { if (getStore().getItem(key) === 'yes') return true; } catch (_) { /* Private browsing. */ }
      }
      return false;
    };
    const remember = () => {
      remembered = true;
      for (const getStore of storage) {
        try { getStore().setItem(key, 'yes'); return; } catch (_) { /* Try session storage. */ }
      }
    };
    const restore = () => {
      document.documentElement.classList.remove('wk-sellout-modal-open');
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      previousFocus = null;
    };
    const close = () => {
      remember();
      clearTimeout(timer);
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      restore();
    };
    const open = () => {
      if (dialog.open || document.hidden) return false;
      const other = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')].some(el => {
        if (el === dialog || el.closest('dialog:not([open]), [hidden]')) return false;
        const rect = el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.bottom > 0 && rect.left < innerWidth && rect.top < innerHeight && getComputedStyle(el).visibility !== 'hidden';
      });
      if (other) return false;
      previousFocus = document.activeElement;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else { dialog.setAttribute('open', ''); dialog.setAttribute('role', 'dialog'); dialog.setAttribute('aria-modal', 'true'); }
      document.documentElement.classList.add('wk-sellout-modal-open');
      dialog.querySelector('[data-wk-sellout-close]')?.focus({ preventScroll: true });
      remember();
      return true;
    };
    document.querySelectorAll('[data-wk-sellout-open]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', open);
    });
    dialog.querySelectorAll('[data-wk-sellout-close]').forEach(button => button.addEventListener('click', close));
    dialog.querySelectorAll('[data-wk-sellout-shop]').forEach(link => link.addEventListener('click', close));
    dialog.addEventListener('close', restore);
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    const autoOpen = () => {
      if (seen() || dialog.dataset.autoOpen !== 'true' || window.Shopify?.designMode) return;
      if (document.hidden) return;
      if (!open() && ++attempts < 20) timer = setTimeout(autoOpen, 500);
    };
    document.addEventListener('visibilitychange', () => { if (!document.hidden) autoOpen(); });
    window.addEventListener('pagehide', () => { clearTimeout(timer); if (dialog.open) close(); });
    timer = setTimeout(autoOpen, 250);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
